export default __webpack_public_path__ + "static/free-trial-bunny-a77c9be1e2f33b7f0da1295689d78b43.svg";